import React from "react";
import {Box, IconButton, Stack, TextField, Tooltip, Typography} from "@mui/material";
import {IconPlus, IconTrash} from "@tabler/icons-react";
import {fieldSx, iconBtnDangerSx, iconBtnSx, sectionLabelSx} from "./routeStyles";

/**
 * The "Params" editor shared by the static and dynamic route tabs.
 *
 * - `params`   current list of strings
 * - `onAdd`    append an empty param
 * - `onChange(index, value)`  commit an edited param (called on blur)
 * - `onRemove(index)`         drop a param
 */
export const RouteParamsList = ({params = [], onAdd, onChange, onRemove}) => (
    <Box>
        <Stack direction="row" alignItems="center" sx={{mb: 0.5}}>
            <Typography sx={{...sectionLabelSx, flex: 1}}>Params</Typography>
            <Tooltip title="Add new param" disableInteractive>
                <IconButton size="small" onClick={onAdd} sx={iconBtnSx}>
                    <IconPlus size={16}/>
                </IconButton>
            </Tooltip>
        </Stack>
        <Stack gap={0.75}>
            {params.map((param, index) => (
                <Stack key={`${param}-${index}`} direction="row" gap={0.75} alignItems="center">
                    <TextField
                        label={`Param ${index + 1}`}
                        size="small"
                        sx={{flex: 1, ...fieldSx}}
                        defaultValue={param}
                        onBlur={(e) => onChange(index, e.target.value)}
                    />
                    <IconButton size="small" onClick={() => onRemove(index)} sx={iconBtnDangerSx}>
                        <IconTrash size={15}/>
                    </IconButton>
                </Stack>
            ))}
        </Stack>
    </Box>
);
